import { SurveyInterface } from 'app/assessment/survey/models';
import { SurveyActions, SurveyActionType } from 'app/assessment/survey/state/actions';
import { SurveyState, SurveyStateInterface } from 'app/assessment/survey/state/models/survey-state.model';

const initialState: SurveyState = new SurveyState({
  ids: [],
  surveys: {},
  selectedSurvey: 0,
  currentSurvey: {},
  surveyProgress: 0,
});

export function surveyReducer(state: SurveyStateInterface = initialState, action: SurveyActions): SurveyStateInterface {
  switch (action.type) {

    // Handle retrieving a fresh load of surveys
    case SurveyActionType.LoadSurveys:
    case SurveyActionType.LoadSurveysFailed:
    case SurveyActionType.LoadCurrentSurvey:
    case SurveyActionType.LoadCurrentSurveyFailed:
      return {
        ...state,
        ids: [],
        surveys: {},
        currentSurvey: {},
      };

    case SurveyActionType.ResetCurrentSurvey:
      return {
        ...state,
        currentSurvey: {},
      };

    // Update the state when we get a new list of surveys
    case SurveyActionType.LoadSurveysCompleted:
      const allSurveys: SurveyInterface[] = action.payload as SurveyInterface[];
      const newSurveys: SurveyInterface[] = allSurveys.filter((survey: SurveyInterface) => !state.surveys[survey.id]);

      const newSurveyIds: number[] = newSurveys.map((survey: SurveyInterface) => survey.id);
      const newSurveyEntities: { [id: number]: SurveyInterface } = newSurveys.reduce(
        (surveys: { [id: number]: SurveyInterface }, survey: SurveyInterface) => {
          return { ...surveys, ...{
            [survey.id]: survey,
          }};
        },
        {});

      return {
        ...state,
        ids: newSurveyIds,
        surveys: { ...state.surveys, ...newSurveyEntities },
      };

    // Apply the updated survey to state
    case SurveyActionType.UpdateSurveyCompleted:
      const survey: SurveyInterface = action.payload as SurveyInterface;
      const updatedSurveys: { [id: number]: SurveyInterface } = state.surveys;
      updatedSurveys[survey.id] = survey;

      return {
        ...state,
        surveys: updatedSurveys,
      };

    // Update the selected survey in state
    case SurveyActionType.SelectSurveyCompleted:
      return {
        ...state,
        selectedSurvey: action.payload as number,
      };

    // Update the selected survey progress in state
    case SurveyActionType.UpdateSurveyProgressCompleted:
      return {
        ...state,
        surveyProgress: action.payload as number,
      };

    // Load the current survey in state
    case SurveyActionType.LoadCurrentSurveyCompleted:
      return {
        ...state,
        currentSurvey: action.payload as SurveyInterface,
      };

    // Update the current survey in state
    case SurveyActionType.UpdateCurrentSurveyCompleted:
      return {
        ...state,
        currentSurvey: action.payload as SurveyInterface,
      };

    // Update the current survey in state
    case SurveyActionType.ResetCurrentSurveyCompleted:
      return {
        ...state,
        currentSurvey: action.payload as SurveyInterface,
      };

    default:
      return state;
  }
}
